<template>
    <v-dialog scrollable :value="exibirModal && requisicaoEditar" persistent :max-width="'90%'">
        <v-card>
            <v-card-title class="primary modal-title" primary-title>
                <span>
                    Request Body
                </span>
                <v-spacer></v-spacer>
                <v-menu v-if="isValidJson(requestBody) && apenasVisualizar" style="display: flex; justify-content: flex-end" offset-y left>
                  <v-btn slot="activator" dark icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                    <v-list class="py-3">
                        <v-list-tile @click.stop>
                            <v-switch v-model="embelezar"/>
                            <span @click="embelezar = !embelezar">Embelezar texto</span>
                        </v-list-tile>
                        <v-list-tile @click.stop v-if="embelezar">
                            <v-switch v-model="exibirAspas"/>
                            <span @click="exibirAspas = !exibirAspas">Adicionar aspas</span>
                        </v-list-tile>
                        <v-list-tile @click.stop v-if="embelezar">
                            <v-switch v-model="urlClicavel"/>
                            <span @click="urlClicavel = !urlClicavel">Ativar links</span>
                        </v-list-tile>
                    </v-list>
                </v-menu>
                <v-btn icon dark @click="$emit('cancelar')">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text v-if="requisicaoEditar">
                <span v-if="apenasVisualizar">
                    Este é o request body da requisição de numero {{requisicaoEditar.id}}:
                </span>
                <span v-else>
                    Altere o request body da requisição de numero {{requisicaoEditar.id}}:
                </span>

                <br>

                <v-divider class="my-3"/>

                <campo-vazio-mensagem v-if="apenasVisualizar && !requestBody" :mensagem="'Não há conteúdo no request body desta requisição!'"/>

                <span v-if="!!requestBody && apenasVisualizar && isValidJson(requestBody) && embelezar"
                      style="white-space: pre-wrap; word-wrap: break-word"
                      v-html="requestBodyEmbelezado()"/>

                <span v-if="!!requestBody && apenasVisualizar && (!isValidJson(requestBody) || !embelezar)"
                      style="white-space: pre-wrap; word-wrap: break-word">{{requestBody}}</span>


                <v-textarea v-if="!apenasVisualizar"
                            v-model="requestBody"
                            class="required-field"
                            :error-messages="errors.collect('Request Body id ' + requisicaoEditar.id)"
                            v-validate="exibirModal?'required': ''"
                            :name="'Request Body id ' + requisicaoEditar.id"
                            label="Request Body"
                            placeholder="Digite o body"
                            rows="6"/>

            </v-card-text>

            <v-card-actions>
                <v-layout v-if="apenasVisualizar" class="justify-center">
                    <az-call-to-action id="botaoFechar"
                                       @click="$emit('cancelar')"
                                       css-class="botao-desativado" class="ma-2 py-2"
                                       slot="actions">
                        Fechar
                    </az-call-to-action>
                </v-layout>
                <v-flex v-else>
                    <div class="lista-opcoes__acao">
                        <az-call-to-action id="botaoCancelar"
                                           @click="$emit('cancelar')"
                                           css-class="botao" class="ma-2 py-2"
                                           slot="actions">
                            Cancelar
                        </az-call-to-action>
                        <az-call-to-action id="botaoConfirmar"
                                           @click="confirmar()"
                                           css-class="botao-desativado" class="ma-2 py-2"
                                           slot="actions">
                            Confirmar
                        </az-call-to-action>
                    </div>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { prettyPrintJson } from 'pretty-print-json'
import CampoVazioMensagem from './CampoVazioMensagem'
export default {
    name: 'ModalEditarRequestBodyRequisicao',
    components: {CampoVazioMensagem},
    props: {
        exibirModal:{
            type: Boolean,
            default: false
        },
        requisicaoEditar:{
            type: Object,
            default: null,
        },
        apenasVisualizar:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            requestBody: null,
            embelezar: true,
            exibirAspas: true,
            urlClicavel: false
        }
    },
    computed:{
        bodyDaRequisicao(){
            return this.requisicaoEditar.requestBody
        },
    },
    mounted() {
        this.requestBody = this.isAnObject(this.bodyDaRequisicao) ? JSON.stringify(this.bodyDaRequisicao) : this.bodyDaRequisicao
        this.requisicaoEditar.requestBody = this.requestBody
    },
    methods:{
        isAnObject(value) {
            return (typeof value === 'object' && value !== null && !Array.isArray(value))
        },
        confirmar() {
            if(!this.requestBody || this.requestBody.trim().length === 0 ){
                throw new Error('Request Body não informado!')
            }
            this.requisicaoEditar.requestBody = this.requestBody
            this.$emit('confirmar', this.requisicaoEditar)
        },
        requestBodyEmbelezado(){
            if(!this.isValidJson(this.requestBody)){
                return ''
            }
            const opcoesPrettify = {
                linkUrls: this.urlClicavel,
                quoteKeys: this.exibirAspas,
                indent: 6
            }
            return prettyPrintJson.toHtml(JSON.parse(this.requestBody), opcoesPrettify)
        },
    }
}
</script>

<style scoped lang="stylus">
    .lista-opcoes
        text-align center

        &__acao
            display flex
            justify-content space-between
            text-align center

    .botao-desativado
        color #777 !important

    .visualizadorJson
        white-space pre-wrap
        word-wrap break-word
</style>
